module.exports = __webpack_public_path__ + "img/curva_duracion.4024af93.png";